import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import TrialBar from './components/TrialBar';
import ThemePicker from './components/ThemePicker';
import Home from './pages/Home';
import Comparison from './pages/Comparison';
import SetupWizard from './pages/SetupWizard';
import MyApplications from './pages/MyApplications';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import Calculator from './pages/Calculator';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import AuthCallback from './pages/AuthCallback';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import AccountingPricing from './pages/AccountingPricing';
import AccountingDashboard from './pages/AccountingDashboard';
import AccountingTeam from './pages/AccountingTeam';
import AdminLayout from './components/AdminLayout';
import AdminRoute from './components/AdminRoute';
import AdminOverview from './pages/admin/AdminOverview';
import AdminApplications from './pages/admin/AdminApplications';
import AdminContacts from './pages/admin/AdminContacts';
import AdminUsers from './pages/admin/AdminUsers';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminFreezones from './pages/admin/AdminFreezones';
import AdminPackages from './pages/admin/AdminPackages';
import AdminReceipts from './pages/admin/AdminReceipts';
import AdminSubscribers from './pages/admin/AdminSubscribers';
import AdminCRM from './pages/admin/AdminCRM';
import AdminCorrespondence from './pages/admin/AdminCorrespondence';
import ReceiptPaymentStatus from './pages/ReceiptPaymentStatus';
import GeideaCheckout from './pages/GeideaCheckout';
import { Toaster } from './components/ui/toaster';

// Synchronous check for OAuth session_id in URL hash
const AppRouter = () => {
  const location = useLocation();
  const path = location.pathname;
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  const hideChrome = path === '/auth/callback';
  const isAdmin = path.startsWith('/admin');
  return (
    <>
      {!hideChrome && <TrialBar />}
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Comparison" element={<Comparison />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/Calculator" element={<Calculator />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/Terms" element={<Terms />} />
        <Route path="/accounting/pricing" element={<AccountingPricing />} />
        <Route path="/accounting" element={<ProtectedRoute><AccountingDashboard /></ProtectedRoute>} />
        <Route path="/accounting/team" element={<ProtectedRoute><AccountingTeam /></ProtectedRoute>} />
        <Route path="/pay/receipt/success" element={<ReceiptPaymentStatus outcome="success" />} />
        <Route path="/pay/receipt/cancel" element={<ReceiptPaymentStatus outcome="cancel" />} />
        <Route path="/pay/geidea/:ref" element={<GeideaCheckout />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        {/* Protected */}
        <Route path="/SetupWizard" element={<ProtectedRoute><SetupWizard /></ProtectedRoute>} />
        <Route path="/MyApplications" element={<ProtectedRoute><MyApplications /></ProtectedRoute>} />
        <Route path="/Dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/Profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        {/* Admin */}
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<AdminOverview />} />
          <Route path="crm" element={<AdminCRM />} />
          <Route path="correspondence" element={<AdminCorrespondence />} />
          <Route path="saas-subscribers" element={<AdminSubscribers />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
          <Route path="freezones" element={<AdminFreezones />} />
          <Route path="packages" element={<AdminPackages />} />
          <Route path="receipts" element={<AdminReceipts />} />
        </Route>
      </Routes>
      {!hideChrome && !isAdmin && <Footer />}
      {!hideChrome && <ThemePicker />}
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="min-h-screen bg-[#f8fafc] text-[#0a0a0a]">
            <AppRouter />
            <Toaster />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
